/// <reference path="../../lib/tsd.d.ts" />

import logging from "../utils/log";

export class TemplateEngine
{
	constructor() {
	}

	//noinspection JSMethodCanBeStatic
	registerHelper(methodName : string, method : Function)
	{
		Handlebars.registerHelper(methodName, method);
	}

	//noinspection JSMethodCanBeStatic
	render(id : string, params : Object = {}) : JQuery
	{
		let node = $("script[data-sxcc-id=" + id + "]");

		if (!node.length) {
			logging.error("TemplateEngine", "Template " + id + " is not defined!");
			return;
		}

		let text = Handlebars.compile(node.html())(params);
		return $("<div />").html(text).contents();
	}

	//noinspection JSMethodCanBeStatic
	renderFromHTML(html : string, params : Object) : JQuery
	{
		let text = Handlebars.compile(html)(params);
		return $(text).contents();
	}

	//noinspection JSMethodCanBeStatic
	registerPartial(id : string )
	{
		Handlebars.registerPartial(id, $("script[data-sxcc-id=" + id + "]").html())
	}
}
